import {FormControl, FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";

/**
 * Loops through all form controls on a formGroup, marking them as touched and focusing on the first invalid control.
 * @param {FormGroup} form
 * @returns {boolean}
 */
export function isFormValid(form: FormGroup): boolean {
    const isValid = form.valid;

    // Touch all controls
    for (const key in form.controls) {
        const control = form.controls[key] as FormControl;
        if (control.invalid) {
            control.markAsTouched();
        }
    }

    // Focus on first invalid control
    if (isValid == false) {
        for (const key in form.controls) {
            const control = form.controls[key] as FormControl;
            if (control.invalid) {
                const element = document.querySelector("[formControlName=" + key + "]") as HTMLElement;
                if (element != null) {element.focus();}
                break;
            }
        }
    }
    return isValid;
}

/**
 * Checks that at least one of the controls on a formGroup fulfils the passed in validator.
 * @param {ValidatorFn} validator
 * @returns {(group: FormGroup) => (ValidationErrors | null)}
 */
export const atLeastOne = (validator: ValidatorFn) => (
    group: FormGroup,
): ValidationErrors | null => {
    const hasAtLeastOne = group && group.controls && Object.keys(group.controls)
        .some(k => !validator(group.controls[k]));

    return hasAtLeastOne ? null : {
        atLeastOne: true,
    };
};